import { Select, Space, Typography } from "antd";

const { Text } = Typography;
const { Option } = Select;

interface AudioDeviceSelectorProps {
  audioInputDevices: MediaDeviceInfo[];
  audioOutputDevices: MediaDeviceInfo[];
  selectedAudioInput: string | null;
  selectedAudioOutput: string | null;
  onAudioInputChange: (deviceId: string) => void;
  onAudioOutputChange: (deviceId: string) => void;
}

export const AudioDeviceSelector = ({
  audioInputDevices,
  audioOutputDevices,
  selectedAudioInput,
  selectedAudioOutput,
  onAudioInputChange,
  onAudioOutputChange,
}: AudioDeviceSelectorProps) => {
  return (
    <div className="space-y-2">
      <Text strong className="text-sm">
        Audio Settings
      </Text>

      <Space direction="vertical" className="w-full">
        {/* Microphone Selection */}
        <div className="flex items-center space-x-2">
          <i className="ri-mic-line text-gray-500"></i>
          <Select
            size="small"
            placeholder="Select microphone"
            value={selectedAudioInput}
            onChange={onAudioInputChange}
            className="flex-1"
            showSearch
            filterOption={(input, option) =>
              (option?.children as unknown as string)
                ?.toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            {audioInputDevices.map((device) => (
              <Option key={device.deviceId} value={device.deviceId}>
                {device.label || `Microphone ${device.deviceId.slice(0, 8)}...`}
              </Option>
            ))}
          </Select>
        </div>

        {/* Speaker Selection */}
        <div className="flex items-center space-x-2">
          <i className="ri-volume-up-line text-gray-500"></i>
          <Select
            size="small"
            placeholder="Select speaker"
            value={selectedAudioOutput}
            onChange={onAudioOutputChange}
            className="flex-1"
            showSearch
            filterOption={(input, option) =>
              (option?.children as unknown as string)
                ?.toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            {audioOutputDevices.map((device) => (
              <Option key={device.deviceId} value={device.deviceId}>
                {device.label || `Speaker ${device.deviceId.slice(0, 8)}...`}
              </Option>
            ))}
          </Select>
        </div>
      </Space>
    </div>
  );
};
